export * from './StaticGoogleMap';
